import restArguments from './restArguments.js';
import unzip from './unzip.js';

// Zip together multiple lists into a single array -- elements that share
// an index go together.
export default restArguments(unzip);



//////////////////
// WEBPACK FOOTER
// /Users/gengis/Documents/WORK/_LOCAL_MAMP/genethon-2020/web/app/themes/genethon/node_modules/underscore/modules/zip.js
// module id = 165
// module chunks = 0